import { PatientListDto } from '@lmt/shared-types';
import {
  Input,
  Props,
} from '@lmt/unicorn-shared/app/components/common/ui-kit/inputs/Input';
import { pages } from '@lmt/unicorn-shared/app/constants/sharedRoutes';
import { useTabs } from '@lmt/unicorn-shared/app/features/navigation/operations';
import { useSubtenantsDict } from '@lmt/unicorn-shared/app/features/subtenants/selectors';
import { localizeNumberWithSource } from '@lmt/unicorn-shared/app/helpers/localization/translations';
import { ReactComponent as ImgOpenLink } from '@lmt/unicorn-shared/app/icons/open-link.svg';
import React from 'react';

import styles from './InputComponentForPatientSearch.module.scss';

export const InputComponentForPatientSearch: React.FC<
  Props & { selectedValue?: PatientListDto }
> = React.forwardRef<
  HTMLInputElement,
  Props & { selectedValue?: PatientListDto }
>(function InputComponentForPatientSearch(props, ref) {
  const tabs = useTabs();
  const subtenants = useSubtenantsDict();
  const patientData =
    typeof props.selectedValue === 'string' ? undefined : props.selectedValue;

  return (
    <Input
      {...props}
      ref={ref}
      endAdornment={
        patientData ? (
          <div className={styles.container}>
            <div className={styles.dataContainer}>
              <div className={styles.number}>
                {localizeNumberWithSource(
                  patientData.number,
                  patientData.numberSource,
                )}
              </div>
              <div className={styles.code}>
                {subtenants[patientData.subtenantId]?.code}
              </div>
              <ImgOpenLink
                className={styles.icon}
                onMouseDown={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                }}
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  tabs.openTab(
                    pages.patientProfile.link({
                      patientId: patientData.id,
                    }),
                  );
                }}
              />
            </div>
          </div>
        ) : undefined
      }
    />
  );
});
